import { ReturnDisclosureInputLabelText } from '../constants/inputText';
import { ManagementStrategyInputLabelText } from '../constants/inputText';
import * as DisclosureType from '../constants/disclosureType';

class BaseAssessmentController {

    constructor(className, disclosureType, disclosureService, _, preFetchedData, $q, $state, componentRegistryService, componentDataService, assessmentService, fileSaver, loggerService) {
        this.className = className;
        this.disclosureType = disclosureType;
        this._ = _;
        this.disclosureService = disclosureService;
        this.disclosureData = preFetchedData.disclosureData || {}; 
        this.q = $q;
        this.state = $state;
        this.componentRegistryService = componentRegistryService;
        this.componentDataService = componentDataService;
        this.assessmentService = assessmentService;
        this.fileSaver = fileSaver;
        this.loggerService = loggerService;
        this.componentDataService.setDto(preFetchedData);
        this.showAcknowledgementsSection = true;
        this.assessmentCommentsLabelText = ManagementStrategyInputLabelText;
        this.returnDisclosureInputLabelText = ReturnDisclosureInputLabelText;
        this.showReturnDisclosureInput = false;
        this.commentRequiredRequestInfo = () => true;
        this.commentRequiredSubmit = () => true;
        this.commentRequired = this.commentRequiredSubmit;
        this.commentRequiredWrapper = () => this.commentRequired();
        this._handleError = (error) => this.loggerService.logError("An error occured. Please try again later.", error, className, true);
    }    

    requestInfo() {
        this.commentRequired = this.commentRequiredRequestInfo;
        let commentComponent = this.componentRegistryService.get("returnComments");
        commentComponent.validateAsync().then((isValid) => {
            if (isValid) {
                let data = {
                    comments: commentComponent.model,
                    disclosureId: this.disclosureData.id
                }
                this.assessmentService.requestInfo(data).then((response) => {
                    if (this._.isEmpty(response.error)) {
                        return this.state.go("/.coi.mytasks");
                    } else {
                        this._handleError(response.error);
                        return { success: false };
                    }
                });
            }
        });
    }

    submit() {
        this.commentRequired = this.commentRequiredSubmit;
        this.validateAll().then((isValid) => {
            if (isValid) {
                let data = {
                    comments: this.componentRegistryService.get("assessorComments").model,
                    disclosureId: this.disclosureData.id,
                    Type: this._.get(this.componentRegistryService.get("managementStrategy").model, "selectedOption.id")

                }

                this.assessmentService.submitAssessment(data).then((submitResponse) => {
                    if (this._.isEmpty(submitResponse.error)) {
                        return this.state.go("/.coi.assessmentsuccess", { disclosureId: this.disclosureData.id, disclosureType: this.disclosureData.type, displayId: this.disclosureData.displayId });
                    } else {
                        this._handleError(submitResponse.error);
                    }
                });
            }
        });
    }

    validateAll() {
        let promises = [];

        this.componentRegistryService.getRegistered().forEach((comp) => {
            if (comp.validateAsync) {
                promises.push(comp.validateAsync());
            }
        });

        return this.q.all(promises).then((results) => {
            return results.every((r) => r !== false);
        });
    }

    toggleAcknowledgements(managementStrategyRequired, disclosureType) {
        if (managementStrategyRequired && disclosureType === DisclosureType.GIFT) {
            this.showAcknowledgementsSection = true;
            this.setAssessmentLabel();
        }
        else if((managementStrategyRequired === true || managementStrategyRequired === false) && disclosureType === DisclosureType.CONFLICT)
        {        
            this.showAcknowledgementsSection = true;
            this.setAssessmentLabel();              
        } else {
            this.showAcknowledgementsSection = false;          
        }
    }
  
    setAssessmentLabel() {
        this.assessmentCommentsLabelText = ManagementStrategyInputLabelText;
    }

    showReturnInfoButton() {
        return this.showAcknowledgementsSection === false;
    }

    showReturnCommentsInput(managementStrategyRequired) {
        return managementStrategyRequired === null || managementStrategyRequired === undefined ? true : false;
    }

    onFileUpload(file) {
        let dto = { disclosureId: this.disclosureData.id, file: file };
        return this.saveFile(dto);
    }

    saveFile(dto) {
        return this.disclosureService.saveFile(dto).then((response) => {
            if (this._.isEmpty(response.error)) {
                this.disclosureData.assessorFiles = response.data;
            } else {
                if (!response.isValidFile) {
                    this.loggerService.logError("Invalid file.", response.error, this.className, true);
                } else {
                    this.loggerService.logError("An error occured. Please try again later.", response.error, this.className, true);
                }
            }
        });
    }

    onFileFetched(fileDto) {
        this.disclosureService.getFile(fileDto).then((response) => {
            this.fileSaver.saveAs(response.data, fileDto.fileName);
        });
    }

    onFileDeleted(fileDto) {
        this.disclosureService.deleteFile(fileDto.disclosureId, fileDto.fileId).then((response) => {
            this.disclosureData.assessorFiles =
                this._.filter(this.disclosureData.assessorFiles, (file) => file.id !== fileDto.fileId);
        });
    }
}

export default BaseAssessmentController;



// WEBPACK FOOTER //
// ./app/assess/base-assessment.controller.js